import React, { useEffect } from 'react';
import { Button, message, notification } from 'antd';
import { isPushSupported, subscribeToPush, syncPushSubscription } from './push';

export const PUSH_DISMISS_KEY = 'pushPromptDismissedAt';
export const PUSH_REPROMPT_MS = 7 * 24 * 60 * 60 * 1000;
const NOTICE_KEY = 'push-onboarding';

export default function usePushOnboarding(userId) {
  useEffect(() => {
    if (!userId || localStorage.getItem('impersonateOrg') || !isPushSupported()) return undefined;
    if (Notification.permission === 'granted') {
      syncPushSubscription().catch((err) => console.warn('Push sync failed:', err));
      return undefined;
    }
    if (Notification.permission !== 'default') return undefined;

    const dismissedAt = Number(localStorage.getItem(PUSH_DISMISS_KEY)) || 0;
    if (Date.now() - dismissedAt < PUSH_REPROMPT_MS) return undefined;
    const dismiss = () => localStorage.setItem(PUSH_DISMISS_KEY, String(Date.now()));
    const enable = async () => {
      notification.destroy(NOTICE_KEY);
      dismiss();
      try {
        await subscribeToPush();
        if (Notification.permission === 'granted') message.success('Notifications are on');
      } catch (err) {
        message.error(err.message || 'Could not enable notifications');
      }
    };

    const timer = setTimeout(() => {
      notification.open({
        key: NOTICE_KEY,
        placement: 'bottomRight',
        duration: 0,
        message: 'Turn on notifications',
        description: 'Get alerts for new texts and Agent Actions, even when this app is closed.',
        btn: <Button onClick={enable}>Turn on</Button>,
        onClose: dismiss
      });
    }, 3000);

    return () => {
      clearTimeout(timer);
      notification.destroy(NOTICE_KEY);
    };
  }, [userId]);
}
